export default {
  'pages.help.title': 'Help',
};
